var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 185,
    viewBox: "0 0 187 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.998 91.9277C186.78 74.1917 181.473 56.8871 171.705 42.0521C161.936 27.217 148.113 15.4693 131.862 8.1926C115.61 0.915857 97.6085 -1.58686 79.9763 0.97903C62.3444 3.54503 45.8159 11.0727 32.3378 22.6759C18.8596 34.279 8.99311 49.4742 3.90014 66.4719C-1.19272 83.4698 -1.30002 101.562 3.59111 118.619C8.48224 135.675 18.1679 150.984 31.5076 162.745C44.8472 174.506 61.2853 182.228 78.8858 185V119.035H55.5102V91.9277H78.8858V71.3355C78.3447 66.5476 78.8659 61.6996 80.4134 57.1339C81.9609 52.5683 84.496 48.3963 87.8399 44.9125C91.1837 41.4286 95.2546 38.7177 99.7661 36.9714C104.278 35.2249 109.12 34.4853 113.949 34.805C120.96 34.9005 127.954 35.5228 134.871 36.6664V59.9345H123.183C121.168 59.6815 119.12 59.8825 117.194 60.5227C115.267 61.1629 113.509 62.2259 112.05 63.6332C110.591 65.0404 109.469 66.756 108.767 68.6527C108.063 70.5502 107.798 72.5803 107.989 74.593V92.1604H133.936L129.728 119.268H108.105V184.418C130.194 180.941 150.3 169.698 164.774 152.728C179.248 135.759 187.133 114.188 186.998 91.9277Z",
    fill: "#009688"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.919907868869aa64a4056652e3d48a11.svg";
export { ForwardRef as ReactComponent };